/**
 * 开票记录
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>开票记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 可开票金额 && 开票信息  -->
    <div class="block-detail-main">
      <div class="block-detail-item el-col el-col-8">
        <div class="info-block">
          <p class="info-title"><span class="title">可开票金额</span></p>
        </div>
        <div class="info-body">
          <div class="info-body-con">
            <div
              lass="info-body-title"
              style="display: flex; align-items: center; margin-bottom: 20px"
            >
              <img
                src="static/home/pur_3.png"
                alt=""
                style="width: 36px; height: 36px; margin-right: 8px"
              />
              <span>可开票金额</span>
            </div>
            <span class="info-body-amount"
              ><span>¥ {{ invoiceAmount }}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="block-detail-item el-col el-col-16">
        <div class="info-block">
          <p class="info-title el-col-16">
            <span
              class="title d-flex justify-content-between align-items-center"
              >开票信息</span
            >
          </p>
        </div>
        <div class="info-body position-relative" style="font-size: 14px">
          <div class="el-row">
            <div class="el-col el-col-12">
              <div class="m_bot5">公司名称： {{ editForm.companyName }}</div>
              <div class="m_bot5">税务登记号： {{ editForm.taxNumber }}</div>
              <div class="m_bot5">开户行： {{ editForm.depositBank }}</div>
              <div class="m_bot5">
                开户行帐号： {{ editForm.depositBankAccount }}
              </div>
              <div class="m_bot5">电话： {{ editForm.phone }}</div>
              <div class="m_bot5">地址： {{ editForm.address }}</div>
            </div>
            <div class="el-col el-col-12">
              <div class="m_bot5">收件人： {{ editForm.addresseeName }}</div>
              <div class="m_bot5">手机号： {{ editForm.mobile }}</div>
              <div class="m_bot5">发送至邮箱： {{ editForm.sendToMail }}</div>
              <div class="m_bot5">
                电子发票格式： {{ editForm.electronicInvoiceFormatStr }}
              </div>
              <div class="m_bot5">邮寄地址： {{ fullMailingAddress }}</div>
            </div>
            <el-button
              size="small"
              type="primary"
              @click="onEditInvoic"
              class="edit-button-bottom-right"
              >编辑</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 搜索筛选 -->
    <el-form :model="formInline" class="user-search" label-width="100px">
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="记录ID :">
            <el-input
              size="small"
              v-model="formInline.recordId"
              placeholder="请输入开票记录ID"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="开票类目 :">
            <el-input
              size="small"
              v-model="formInline.invoiceCategory"
              placeholder="请输入开票类目"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="开票状态 :">
            <el-select
              size="small"
              v-model="formInline.recordStatus"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in status_list"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="申请类型 :">
            <el-select
              size="small"
              v-model="formInline.recordType"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in typeList"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="申请时间 : ">
            <el-date-picker
              size="small"
              v-model="date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label-width="30px">
            <el-button size="small" type="primary" @click="search"
              >搜索</el-button
            >
            <el-button size="small" @click="reset()">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button size="small" type="primary" @click="open_apply"
        >开票申请</el-button
      >
      <el-button
        size="small"
        type="primary"
        @click="open_pre_apply"
        v-if="preIssued === 1"
        >预开申请</el-button
      >
      <el-button size="small" @click="exportdata">导出数据</el-button>
      <el-button size="small" @click="exportinvoice">导出发票</el-button>
      <el-button size="small" @click="exportpath">导出记录</el-button>
    </div>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column
        fixed
        prop="recordId"
        label="开票记录ID"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.recordId)">
            {{ scope.row.recordId }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="invoiceAmount"
        label="开票金额"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.invoiceAmount.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="invoiceCategory"
        label="发票类目"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.invoiceCategory)">{{
            scope.row.invoiceCategory ? scope.row.invoiceCategory : "-"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="recordStatus"
        label="开票状态"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            :style="{
              color: getStatusColor(scope.row.recordStatus),
            }"
          >
            {{ status_list[scope.row.recordStatus - 1].label }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="recordTypeStr"
        label="申请类型"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="remark" label="备注" show-overflow-tooltip>
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.remark)">
            {{ scope.row.remark }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="submissionTime"
        label="申请时间"
        show-overflow-tooltip
      >
      </el-table-column>

      <el-table-column fixed="right" align="left" label="操作" min-width="130">
        <template slot-scope="scope">
          <el-tooltip
            content="您还未全部回款，不可抵扣预开"
            placement="top"
            :disabled="invoiceAmount >= 0"
          >
            <el-button
              v-if="
                scope.row.recordType === 1 &&
                scope.row.isDeduct === 0 &&
                (scope.row.recordStatus === 1 || scope.row.recordStatus === 2)
              "
              size="small"
              type="primary"
              plain
              :loading="deductLoading"
              :disabled="invoiceAmount < 0"
              @click="handleDeduction(scope.row)"
            >
              抵扣
            </el-button>
          </el-tooltip>
          <el-button
            size="small"
            type="primary"
            plain
            @click="handleDetail(scope.row.recordId, scope.row.recordStatus)"
            >开票详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="editInvoiceTitle"
      :visible.sync="editInvoiceVisible"
      width="800px"
      @close="closeEditInvoicDialog"
    >
      <el-form
        label-width="110px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="公司名称:" prop="companyName">
              <el-input
                style="width: 240px"
                :disabled="isDisabled"
                size="small"
                v-model="editForm.companyName"
                auto-complete="off"
                placeholder="请输入公司名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税务登记号:" prop="taxNumber">
              <el-input
                style="width: 240px"
                :disabled="isDisabled"
                size="small"
                v-model="editForm.taxNumber"
                auto-complete="off"
                placeholder="请输入税务登记号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开户行:" prop="depositBank">
              <el-input
                style="width: 240px"
                size="small"
                v-model="editForm.depositBank"
                auto-complete="off"
                placeholder="请输入开户行"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行账号:" prop="depositBankAccount">
              <el-input
                style="width: 240px"
                size="small"
                v-model="editForm.depositBankAccount"
                auto-complete="off"
                placeholder="请输入开户行账号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="电话:" prop="phone">
              <el-input
                style="width: 240px"
                size="small"
                v-model="editForm.phone"
                auto-complete="off"
                placeholder="请输入电话"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址" prop="address">
              <el-input
                style="width: 240px"
                size="small"
                v-model="editForm.address"
                auto-complete="off"
                placeholder="请输入地址"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="收件人:" prop="addresseeName">
              <el-input
                style="width: 240px"
                size="small"
                v-model="editForm.addresseeName"
                auto-complete="off"
                placeholder="请输入收件人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号:" prop="mobile">
              <el-input
                style="width: 240px"
                size="small"
                v-model="editForm.mobile"
                auto-complete="off"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发送至邮箱:" prop="sendToMail">
              <el-input
                style="width: 240px"
                size="small"
                v-model="editForm.sendToMail"
                auto-complete="off"
                placeholder="请输入邮箱"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电子发票格式:">
              <el-select
                size="small"
                v-model="editForm.electronicInvoiceFormat"
                placeholder="请选择"
                style="width: 240px"
              >
                <el-option
                  v-for="(val, index) in electronicInvoiceFormatList"
                  :label="val.label"
                  :value="val.value"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="邮寄地址:">
              <el-select
                size="small"
                v-model="editForm.mailingAddress.province"
                auto-complete="off"
                placeholder="请选择"
                @change="provinceChanged"
                style="width: 240px"
              >
                <el-option
                  v-for="(val, index) in province_list"
                  :label="val.name"
                  :value="val"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                size="small"
                v-model="editForm.mailingAddress.city"
                auto-complete="off"
                placeholder="请选择"
                @change="cityChanged"
                style="width: 240px"
              >
                <el-option
                  v-for="(val, index) in city_list"
                  :label="val.name"
                  :value="val"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                size="small"
                v-model="editForm.mailingAddress.district"
                auto-complete="off"
                placeholder="请选择"
                style="width: 240px"
              >
                <el-option
                  v-for="(val, index) in district_list"
                  :label="val.name"
                  :value="val.name"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                size="small"
                v-model="editForm.mailingAddress.detail"
                auto-complete="off"
                placeholder="请输入邮寄地址"
                style="width: 240px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeEditInvoicDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitEditForm()"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  invoiceRecords,
  invoiceInfo,
  exportinvoicerecords,
  invoicezip,
  updateInvoiceInfo,
  addInvoiceInfo,
  deductPreIssued,
} from "../../api/userMG";
import { MessageBox } from "element-ui";
import Pagination from "../../components/Pagination";
import { china } from "../../common/area.js";
export default {
  data() {
    return {
      multipleSelection: [],
      electronicInvoiceFormatList: [
        {
          label: "PDF格式",
          value: 1,
        },
      ],
      status_list: [
        {
          label: "处理中",
          value: 1,
        },
        {
          label: "成功",
          value: 2,
        },
        {
          label: "失败",
          value: 3,
        },
        {
          label: "作废",
          value: 4,
        },
        {
          label: "作废重传",
          value: 5,
        },
      ],
      typeList: [
        {
          label: "正常申请",
          value: 0,
        },
        {
          label: "预开",
          value: 1,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      deductLoading: false,
      preIssued: 0,
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      date: [],
      province_list: [],
      city_list: [],
      district_list: [],
      editInvoiceTitle: "编辑开票信息",
      editInvoiceVisible: false,
      isDisabled: false,
      submitBtnType: "add",
      title: "添加",
      editForm: {
        companyName: "",
        taxNumber: "",
        depositBank: "",
        depositBankAccount: "",
        phone: "",
        address: "",
        addresseeName: "",
        mobile: "",
        sendToMail: "",
        electronicInvoiceFormat: 1,
        electronicInvoiceFormatStr: "",
        mailingAddress: {
          city: "",
          district: "",
          province: "",
          detail: "",
        },
      },
      // rules表单验证
      rules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        taxNumber: [
          { required: true, message: "请输入税务登记号", trigger: "blur" },
        ],
        depositBank: [
          { required: true, message: "请输入开户行", trigger: "blur" },
        ],
        depositBankAccount: [
          { required: true, message: "请输入开户行账号", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入电话", trigger: "blur" }],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
      },
      formInline: {
        page: 1,
        pageSize: 10,
        varLable: "",
        varName: "",
        recordStatus: "",
        recordType: "",
        startDate: "",
        endDate: "",
        invoiceCategory: "",
        recordId: "",
        merchantName: "",
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      recordData: [],
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
      invoiceAmount: JSON.parse(localStorage.getItem("user_info")).invoiceAmount
        ? JSON.parse(localStorage.getItem("user_info")).invoiceAmount.toFixed(2)
        : Number(0).toFixed(2),
      balance: JSON.parse(localStorage.getItem("user_info")).balance
        ? JSON.parse(localStorage.getItem("user_info")).balance.toFixed(2)
        : Number(0).toFixed(2),
      info: {},
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
    this.getInvoiceInfo();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getStatusColor(status) {
      // 根据状态值返回对应的颜色
      switch (status) {
        case 1:
          return "#409EFF"; // 蓝色
        case 2:
          return "#67C23A"; // 绿色
        case 3:
          return "#909399"; // 灰色
        case 4:
          return "#F56C6C"; // 红色
        case 5:
          return "#E6A23C"; // 黄色
        default:
          return "#303133"; // 默认黑色
      }
    },
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(
          () => {
            this.$message({
              message: "已复制",
              type: "success",
            });
          },
          () => {
            this.$message.error("复制失败，请重试！");
          }
        );
      } else {
        // 兼容旧浏览器
        const input = document.createElement("textarea");
        input.value = text;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");
          this.$message({
            message: "已复制",
            type: "success",
          });
        } catch (err) {
          this.$message.error("复制失败，请重试！");
        }
        document.body.removeChild(input);
      }
    },
    open_apply() {
      if (this.invoiceAmount < 0) {
        this.$message.error("请完成回款后再申请");
        return;
      }

      this.$router.push({ path: "/payCenter/applybilling" });
    },
    open_pre_apply() {
      if (this.invoiceAmount < 0) {
        this.$message.error("请完成回款后再次申请预开");
        return;
      }

      if (this.balance <= 0 || this.invoiceAmount == 0) {
        this.$message.error("请充值押金后再进行预开申请");
        return;
      }
      this.$router.push({ path: "/payCenter/preApplyInvoice" });
    },

    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        varLable: "",
        varName: "",
        recordStatus: "",
        recordType: "",
        startDate: "",
        endDate: "",
        invoiceCategory: "",
        recordId: "",
        merchantName: "",
      };

      this.date = [];

      this.getdata(this.formInline);
    },
    handleDeduction(row) {
      const message = `确认抵扣此预开记录，预开金额 ${row.invoiceAmount.toFixed(
        2
      )}`;
      MessageBox.confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deductLoading = true;
          deductPreIssued(row.recordId).then((res) => {
            this.deductLoading = false;
            if (res.msg == "success") {
              this.getdata(this.formInline);
              this.$message({
                type: "success",
                message: "抵扣成功",
              });
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          // 用户点击取消，可添加相应逻辑，这里可留空
        });
    },
    handleDetail(id, recordStatus) {
      if (recordStatus === 3) {
        this.$message({
          type: "error",
          message: "失败状态不可查看",
        });
        return;
      }

      this.$router.push({
        path: "/payCenter/invoiceDetail",
        query: {
          id: id,
        },
      });
    },
    exportdata() {
      const [startDate = "", endDate = ""] = this.date || [];

      let params = {
        page: 1,
        pageSize: 99999999,
        recordStatus: this.formInline.recordStatus,
        recordType: this.formInline.recordType,
        startDate: startDate,
        endDate: endDate,
        invoiceCategory: this.formInline.invoiceCategory,
        recordId: this.formInline.recordId,
        merchantName: this.formInline.merchantName,
      };
      exportinvoicerecords(params).then((res) => {
        if (res.msg == "success") {
          window.open(res.data.downloadUrl);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    exportinvoice() {
      const [startDate = "", endDate = ""] = this.date || [];

      let params = {
        page: 1,
        pageSize: 99999999,
        recordStatus: this.formInline.recordStatus,
        recordType: this.formInline.recordType,
        startDate: startDate,
        endDate: endDate,
        invoiceCategory: this.formInline.invoiceCategory,
        recordId: this.formInline.recordId,
        merchantName: this.formInline.merchantName,
      };
      invoicezip(params).then((res) => {
        this.$router.push({ path: "/payCenter/payExportList" });
      });
    },
    exportpath() {
      this.$router.push({ path: "/payCenter/payExportList" });
    },
    getInvoiceInfo() {
      invoiceInfo()
        .then((res) => {
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.invoiceAmount = res.data.canInvoiceAmount;
            this.balance = res.data.balance;
            this.preIssued = res.data.preIssued;
            const data = res.data;
            this.editForm = {
              companyName: data.companyName || "",
              taxNumber: data.taxNumber || "",
              depositBank: data.depositBank || "",
              depositBankAccount: data.depositBankAccount || "",
              phone: data.phone || "",
              address: data.address || "",
              addresseeName: data.addresseeName || "",
              mobile: data.mobile || "",
              sendToMail: data.sendToMail || "",
              electronicInvoiceFormat: data.electronicInvoiceFormat || "",
              mailingAddress: {
                city: data.mailingAddress.city || "",
                district: data.mailingAddress.district || "",
                province: data.mailingAddress.province || "",
                detail: data.mailingAddress.detail || "",
              },
              remark: data.remark || "",
              electronicInvoiceFormat: data.electronicInvoiceFormat || 1,
              electronicInvoiceFormatStr: data.electronicInvoiceFormatStr || "",
            };

            if (!!this.editForm.companyName && !!this.editForm.taxNumber) {
              this.isDisabled = true;
              this.submitBtnType = "edit";
            }
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 获取公司列表
    getdata(parameter) {
      const [startDate = "", endDate = ""] = this.date || [];

      parameter.startDate = startDate;
      parameter.endDate = endDate;

      invoiceRecords(parameter)
        .then((res) => {
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;

            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    provinceChanged(val) {
      this.editForm.mailingAddress.city = "";
      this.editForm.mailingAddress.district = "";
      this.city_list = val.city;
      this.editForm.mailingAddress.province = val.name;
    },
    cityChanged(val) {
      this.editForm.mailingAddress.district = "";
      this.district_list = val.area;
      this.editForm.mailingAddress.city = val.name;
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    // 编辑、增加页面保存方法
    submitEditForm() {
      this.loading = true;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          if (this.submitBtnType == "edit") {
            updateInvoiceInfo(this.editForm)
              .then((res) => {
                this.editInvoiceVisible = false;
                this.loading = false;
                if (res.msg == "success") {
                  this.getdata(this.formInline);
                  this.$message({
                    type: "success",
                    message: "编辑成功",
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.editInvoiceVisible = false;
                this.loading = false;
                this.$message.error("操作失败，请稍后再试！");
              });
          } else {
            addInvoiceInfo(this.editForm)
              .then((res) => {
                this.editInvoiceVisible = false;
                this.loading = false;
                if (res.msg == "success") {
                  this.isDisabled = true;
                  this.submitBtnType = "edit";
                  this.getdata(this.formInline);
                  this.$message({
                    type: "success",
                    message: "编辑成功",
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.editInvoiceVisible = false;
                this.loading = false;
                this.$message.error("操作失败，请稍后再试！");
              });
          }
        } else {
          this.loading = false;
          return false;
        }
      });
    },

    onEditInvoic() {
      this.editInvoiceVisible = true;
      this.province_list = china;
    },
    // 关闭编辑、增加弹出框
    closeEditInvoicDialog() {
      this.editInvoiceVisible = false;
    },
  },

  computed: {
    fullMailingAddress() {
      const { province, city, district, detail } =
        this.editForm.mailingAddress || {};

      // 定义拼接顺序，并过滤掉空值和仅含空格的字符串
      const parts = [province, city, district, detail]
        .map((part) => part && part.trim()) // 处理并去除空格
        .filter(Boolean); // 过滤掉假值（如 undefined, null, 空字符串等）

      // 按照顺序拼接非空的部分，用连字符连接
      return parts.join("-") || ""; // 如果没有任何非空部分，则返回空字符串
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
.block-detail-main {
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
}

.info-block .info-title {
  display: flex;
  width: 100%;
  padding: 0 32px;
  line-height: 50px;
  border-bottom: 1px solid #e5e5e5;
}
.info-block .info-title .title {
  font-size: 16px;
}
.block-detail-main .block-detail-item .info-body {
  border-radius: 2px;
  padding: 24px 32px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: calc(100% - 58px);
}
.block-detail-main .block-detail-item .info-body .info-body-con {
  width: 320px;
  background: #6255f2;
  color: #fff;
  border-radius: 7px;
  padding: 30px 20px;
  box-sizing: border-box;
}
.block-detail-main
  .block-detail-item
  .info-body
  .info-body-con
  .info-body-title {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.block-detail-main
  .block-detail-item
  .info-body
  .info-body-con
  .info-body-amount {
  width: 100%;
  display: flex;
  flex-direction: column;
  color: #fff;
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.2);
  padding-bottom: 16px;
}
.block-detail-main
  .block-detail-item
  .info-body
  .info-body-con
  .info-body-amount
  span:first-child {
  font-size: 30px;
  font-weight: 500;
  margin-bottom: 4px;
}
.m_bot5 {
  margin-bottom: 15px;
}
.btnNoBorderBlue {
  color: #1985ff;
  cursor: pointer;
}
.m_bot5 {
  margin-bottom: 15px;
}

/* 编辑按钮右上角 */
/* .d-flex {
  display: flex;
}

.justify-content-between {
  justify-content: space-between;
}

.align-items-center {
  align-items: center;
}

.info-title {
  font-size: 14px; 
}

.edit-button {
  text-decoration: underline; 
  font-size: 14px; 
  margin-left: auto; 
  margin-right: 16px; 
   box-sizing: border-box;
} */
.position-relative {
  position: relative;
}

.edit-button-bottom-right {
  position: absolute;
  bottom: -20px; /* 调整底部距离 */
  right: -25px;
  margin: 8px; /* 调整边距以适应设计 */
}
</style>

 


// WEBPACK FOOTER //
// src/views/payCenter/billingRecordList.vue